import { DOWNLOAD_EXCEL_CONSTANTS, STATUS } from "../constant";

const initState = {
  nodalOfficer: {
    isLoading: false,
    downloadingSrc: ""
  },
  weeklyReport: {
    show: true,
    title: "PMG Report",
    isLoading: false,
    downloadingSrc: ""
  },
  issueWithComments: {
    show: true,
    title: "Issue With Comments",
    isLoading: false,
    downloadingSrc: ""
  },
  decission: {
    show: true,
    title: "Issue With Decisions",
    isLoading: false,
    downloadingSrc: ""
  },
  ministryStateIssueReport: {
    show: true,
    title: "Ministry/State Issue Report",
    isLoading: false,
    downloadingSrc: ""
  },
  userDetailReports: {
    show: true,
    title: "Users Report",
    isLoading: false,
    downloadingSrc: ""
  },
  dashboardSummary: {
    show: true,
    title: "Dashboard Summary",
    isLoading: false,
    downloadingSrc: ""
  },
  projectListDownload: {
    show: true,
    title: "Project List",
    isLoading: false,
    downloadingSrc: ""
  },
  agendaListDownload: {
    show: true,
    title: "Agenda List",
    isLoading: false,
    downloadingSrc: ""
  },
  issueListDownload: {
    show: true,
    title: "Issue List",
    isLoading: false,
    downloadingSrc: ""
  },
  issueBriefDownload: {
    show: true,
    title: "Issue Brief",
    isLoading: false,
    downloadingSrc: ""
  },
  issueBriefPdfDownload: {
    show: true,
    title: "Issue Brief PDF",
    isLoading: false,
    downloadingSrc: ""
  },
  misDownload: {
    show: true,
    title: "Issue List",
    isLoading: false,
    downloadingSrc: ""
  },
  agendaDownload: {
    show: true,
    title: "Issue List",
    isLoading: false,
    downloadingSrc: ""
  },
  agendaUpload: {
    show: true,
    title: "Issue List",
    isLoading: false,
    downloadingSrc: ""
  },
  ministryState: {},
  projectDetailDocumentDownload: {
    isLoading: false,
    downloadingSrc: ""
  },
  userManual: {
    isLoading: false,
    userManualList: []
  },
  userManualDashboard: {
    isLoading: false,
    downloadingSrc: ""
  },
  weeklyReportForStatePmg: {
    show: true,
    title: "  Weekly Report For State PMG",
    isLoading: false,
    downloadingSrc: ""
  },
  march24Report: {
    show: true,
    title: "March24 Report ",
    isLoading: false,
    downloadingSrc: ""
  },
  uploadAgendaTmp: {
    show: true,
    title: "Upload Agenda Template",
    isLoading: false,
    downloadingSrc: null
  },
  uploadProjectIssues: {
    show: true,
    title: "Upload Project Issues",
    isLoading: false,
    downloadingSrc: "",
    uploadedList: []
  }
};

export function donwloadExcelReducer(state = initState, action) {
  switch (action.type) {
    case DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._START:
      return {
        ...state,
        nodalOfficer: {
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._SUCCESS:
      return {
        ...state,
        nodalOfficer: {
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._FAILURE:
      return {
        ...state,
        nodalOfficer: {
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._START:
      return {
        ...state,
        weeklyReport: {
          ...state.weeklyReport,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._SUCCESS:
      return {
        ...state,
        weeklyReport: {
          ...state.weeklyReport,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._FAILURE:
      return {
        ...state,
        weeklyReport: {
          ...state.weeklyReport,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._CLEAR:
      return {
        ...state,
        weeklyReport: {
          ...state.weeklyReport,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._START:
      return {
        ...state,
        userDetailReports: {
          ...state.userDetailReports,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._SUCCESS:
      return {
        ...state,
        userDetailReports: {
          ...state.userDetailReports,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._FAILURE:
      return {
        ...state,
        userDetailReports: {
          ...state.userDetailReports,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._CLEAR:
      return {
        ...state,
        userDetailReports: {
          ...state.userDetailReports,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._START:
      return {
        ...state,
        issueWithComments: {
          ...state.issueWithComments,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._SUCCESS:
      return {
        ...state,
        issueWithComments: {
          ...state.issueWithComments,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._FAILURE:
      return {
        ...state,
        issueWithComments: {
          ...state.issueWithComments,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._CLEAR:
      return {
        ...state,
        issueWithComments: {
          ...state.issueWithComments,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DECISSION._START:
      return {
        ...state,
        decission: {
          ...state.decission,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DECISSION._SUCCESS:
      return {
        ...state,
        decission: {
          ...state.decission,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DECISSION._FAILURE:
      return {
        ...state,
        decission: {
          ...state.decission,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DECISSION._CLEAR:
      return {
        ...state,
        decission: {
          ...state.decission,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._START:
      return {
        ...state,
        ministryStateIssueReport: {
          ...state.ministryStateIssueReport,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._SUCCESS:
      return {
        ...state,
        ministryStateIssueReport: {
          ...state.ministryStateIssueReport,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._FAILURE:
      return {
        ...state,
        ministryStateIssueReport: {
          ...state.ministryStateIssueReport,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._CLEAR:
      return {
        ...state,
        ministryStateIssueReport: {
          ...state.ministryStateIssueReport,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._START:
      return {
        ...state,
        dashboardSummary: {
          ...state.dashboardSummary,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._SUCCESS:
      return {
        ...state,
        dashboardSummary: {
          ...state.dashboardSummary,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._FAILURE:
      return {
        ...state,
        dashboardSummary: {
          ...state.dashboardSummary,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._CLEAR:
      return {
        ...state,
        dashboardSummary: {
          ...state.dashboardSummary,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._START:
      return {
        ...state,
        agendaListDownload: {
          ...state.agendaListDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._SUCCESS:
      return {
        ...state,
        agendaListDownload: {
          ...state.agendaListDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._FAILURE:
      return {
        ...state,
        agendaListDownload: {
          ...state.agendaListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._CLEAR:
      return {
        ...state,
        agendaListDownload: {
          ...state.agendaListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._START:
      return {
        ...state,
        projectListDownload: {
          ...state.projectListDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._SUCCESS:
      return {
        ...state,
        projectListDownload: {
          ...state.projectListDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._FAILURE:
      return {
        ...state,
        projectListDownload: {
          ...state.projectListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._CLEAR:
      return {
        ...state,
        projectListDownload: {
          ...state.projectListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._START:
      return {
        ...state,
        issueListDownload: {
          ...state.issueListDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._SUCCESS:
      return {
        ...state,
        issueListDownload: {
          ...state.issueListDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._FAILURE:
      return {
        ...state,
        issueListDownload: {
          ...state.issueListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._CLEAR:
      return {
        ...state,
        issueListDownload: {
          ...state.issueListDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._START:
      return {
        ...state,
        issueBriefDownload: {
          ...state.issueBriefDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._SUCCESS:
      return {
        ...state,
        issueBriefDownload: {
          ...state.issueBriefDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._FAILURE:
      return {
        ...state,
        issueBriefDownload: {
          ...state.issueBriefDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._CLEAR:
      return {
        ...state,
        issueBriefDownload: {
          ...state.issueBriefDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._START:
      return {
        ...state,
        issueBriefPdfDownload: {
          ...state.issueBriefPdfDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._SUCCESS:
      return {
        ...state,
        issueBriefPdfDownload: {
          ...state.issueBriefPdfDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._FAILURE:
      return {
        ...state,
        issueBriefPdfDownload: {
          ...state.issueBriefPdfDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._CLEAR:
      return {
        ...state,
        issueBriefPdfDownload: {
          ...state.issueBriefPdfDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._START:
      return {
        ...state,
        misDownload: {
          ...state.misDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._SUCCESS:
      return {
        ...state,
        misDownload: {
          ...state.misDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._FAILURE:
      return {
        ...state,
        misDownload: {
          ...state.misDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._CLEAR:
      return {
        ...state,
        misDownload: {
          ...state.misDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._START:
      return {
        ...state,
        agendaDownload: {
          ...state.agendaDownload,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._SUCCESS:
      return {
        ...state,
        agendaDownload: {
          ...state.agendaDownload,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._FAILURE:
      return {
        ...state,
        agendaDownload: {
          ...state.agendaDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._CLEAR:
      return {
        ...state,
        agendaDownload: {
          ...state.agendaDownload,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_UPLOAD._START:
      return {
        ...state,
        agendaUpload: {
          ...state.agendaUpload,
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_UPLOAD._SUCCESS:
      return {
        ...state,
        agendaUpload: {
          ...state.agendaUpload,
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_UPLOAD._FAILURE:
      return {
        ...state,
        agendaUpload: {
          ...state.agendaUpload,
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._START:
      return {
        ...state,
        ministryState: {
          ...state.ministryState,
          [action.payload.id]: {
            isLoading: true,
            downloadingSrc: ""
          }
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._SUCCESS:
      return {
        ...state,
        ministryState: {
          ...state.ministryState,
          [action.payload.id]: {
            isLoading: false,
            downloadingSrc: action.payload.url
          }
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._FAILURE:
      return {
        ...state,
        ministryState: {}
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._CLEAR:
      return {
        ...state,
        ministryState: {
          ...state.ministryState,
          [action.payload.id]: {
            isLoading: false,
            downloadingSrc: ""
          }
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._START:
      return {
        ...state,
        projectDetailDocumentDownload: {
          isLoading: true,
          downloadingSrc: ""
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._SUCCESS:
      return {
        ...state,
        projectDetailDocumentDownload: {
          isLoading: false,
          downloadingSrc: action.payload.url
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._FAILURE:
      return {
        ...state,
        projectDetailDocumentDownload: {}
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._CLEAR:
      return {
        ...state,
        projectDetailDocumentDownload: {
          isLoading: false,
          downloadingSrc: ""
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._START:
      return {
        ...state,
        userManual: {
          isLoading: true,
          userManualList: []
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._SUCCESS:
      return {
        ...state,
        userManual: {
          isLoading: false,
          userManualList: action.payload
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._FAILURE:
      return {
        ...state,
        userManual: {
          isLoading: false,
          userManualList: []
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL._SUCCESS:
      return {
        ...state,
        userManualDashboard: {
          isLoading: false,
          downloadingSrc: action.payload
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._START:
      return {
        ...state,
        weeklyReportForStatePmg: {
          ...state.weeklyReportForStatePmg,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._SUCCESS:
      return {
        ...state,
        weeklyReportForStatePmg: {
          ...state.weeklyReportForStatePmg,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._FAILURE:
      return {
        ...state,
        weeklyReportForStatePmg: {
          ...state.weeklyReportForStatePmg,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._CLEAR:
      return {
        ...state,
        weeklyReportForStatePmg: {
          ...state.weeklyReportForStatePmg,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2._START:
      return {
        ...state,
        agendaMeetingPptv2: {
          ...state.agendaMeetingPptv2,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2._SUCCESS:
      return {
        ...state,
        agendaMeetingPptv2: {
          ...state.agendaMeetingPptv2,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2._FAILURE:
      return {
        ...state,
        agendaMeetingPptv2: {
          ...state.agendaMeetingPptv2,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2._CLEAR:
      return {
        ...state,
        agendaMeetingPptv2: {
          ...state.agendaMeetingPptv2,
          downloadingSrc: "",
          isLoading: false
        }
      };
    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE._START:
      return {
        ...state,
        agendaMeetingPptv2WithoutIssue: {
          ...state.agendaMeetingPptv2WithoutIssue,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE._SUCCESS:
      return {
        ...state,
        agendaMeetingPptv2WithoutIssue: {
          ...state.agendaMeetingPptv2WithoutIssue,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE._FAILURE:
      return {
        ...state,
        agendaMeetingPptv2WithoutIssue: {
          ...state.agendaMeetingPptv2WithoutIssue,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE._CLEAR:
      return {
        ...state,
        agendaMeetingPptv2WithoutIssue: {
          ...state.agendaMeetingPptv2WithoutIssue,
          downloadingSrc: "",
          isLoading: false
        }
      };
    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT._START:
      return {
        ...state,
        agendaMeetingPptv2PragatiFormat: {
          ...state.agendaMeetingPptv2PragatiFormat,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT._SUCCESS:
      return {
        ...state,
        agendaMeetingPptv2PragatiFormat: {
          ...state.agendaMeetingPptv2PragatiFormat,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT._FAILURE:
      return {
        ...state,
        agendaMeetingPptv2PragatiFormat: {
          ...state.agendaMeetingPptv2PragatiFormat,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT._CLEAR:
      return {
        ...state,
        agendaMeetingPptv2PragatiFormat: {
          ...state.agendaMeetingPptv2PragatiFormat,
          downloadingSrc: "",
          isLoading: false
        }
      };
    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._START:
      return {
        ...state,
        agendaMeetingCabSecPpt: {
          ...state.agendaMeetingCabSecPpt,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._SUCCESS:
      return {
        ...state,
        agendaMeetingCabSecPpt: {
          ...state.agendaMeetingCabSecPpt,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._FAILURE:
      return {
        ...state,
        agendaMeetingCabSecPpt: {
          ...state.agendaMeetingCabSecPpt,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._CLEAR:
      return {
        ...state,
        agendaMeetingCabSecPpt: {
          ...state.agendaMeetingCabSecPpt,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._START:
      return {
        ...state,
        agendaMeetingPpt: {
          ...state.agendaMeetingPpt,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._SUCCESS:
      return {
        ...state,
        agendaMeetingPpt: {
          ...state.agendaMeetingPpt,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._FAILURE:
      return {
        ...state,
        agendaMeetingPpt: {
          ...state.agendaMeetingPpt,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._CLEAR:
      return {
        ...state,
        agendaMeetingPpt: {
          ...state.agendaMeetingPpt,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._START:
      return {
        ...state,
        agendaMeetingExcel: {
          ...state.agendaMeetingExcel,
          downloadingSrc: "",
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._SUCCESS:
      return {
        ...state,
        agendaMeetingExcel: {
          ...state.agendaMeetingExcel,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._FAILURE:
    case DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._CLEAR:
      return {
        ...state,
        agendaMeetingExcel: {
          ...state.agendaMeetingExcel,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._START:
      return {
        ...state,
        milestoneAuditDownload: {
          isLoading: true,
          downloadingSrc: ""
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._SUCCESS:
      return {
        ...state,
        milestoneAuditDownload: {
          isLoading: false,
          downloadingSrc: action.payload
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._FAILURE:
      return {
        ...state,
        milestoneAuditDownload: {}
      };

    case DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._CLEAR:
      return {
        ...state,
        milestoneAuditDownload: {
          isLoading: false,
          downloadingSrc: ""
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._START:
      return {
        ...state,
        march24Report: {
          ...state.march24Report,
          downloadingSrc: "",
          isLoading: true
        }
      };
    case DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._SUCCESS:
      return {
        ...state,
        march24Report: {
          ...state.march24Report,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._FAILURE:
      return {
        ...state,
        march24Report: {
          ...state.march24Report,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._CLEAR:
      return {
        ...state,
        march24Report: {
          ...state.march24Report,
          downloadingSrc: "",
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._START:
      return {
        ...state,
        uploadAgendaTmp: {
          ...state.uploadAgendaTmp,
          downloadingSrc: null,
          isLoading: true
        }
      };
    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._SUCCESS:
      return {
        ...state,
        uploadAgendaTmp: {
          ...state.uploadAgendaTmp,
          downloadingSrc: action.payload,
          isLoading: false,
          time: new Date()
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._FAILURE:
      return {
        ...state,
        uploadAgendaTmp: {
          ...state.uploadAgendaTmp,
          downloadingSrc: null,
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._CLEAR:
      return {
        ...state,
        uploadAgendaTmp: {
          ...state.uploadAgendaTmp,
          downloadingSrc: null,
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._START:
      return {
        ...state,
        uploadProjectIssues: {
          ...state.uploadProjectIssues,
          isLoading: true
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._SUCCESS:
      return {
        ...state,
        uploadProjectIssues: {
          ...state.uploadProjectIssues,
          isLoading: false,
          uploadedList: action.payload
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._FAILURE:
      return {
        ...state,
        uploadProjectIssues: {
          ...state.uploadProjectIssues,
          isLoading: false
        }
      };

    case DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._CLEAR:
      return {
        ...state,
        uploadProjectIssues: {
          ...state.uploadProjectIssues,
          isLoading: false,
          uploadedList: []
        }
      };

    default:
      return state;
  }
}
